var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.682824 0.701838L1.43288 0.682728C1.59493 0.678643 1.75313 0.732367 1.87918 0.834282C2.00523 0.936197 2.09089 1.07965 2.12083 1.23896L3.95673 11.0306C3.98603 11.1872 4.06913 11.3285 4.19165 11.4302C4.31417 11.5319 4.46839 11.5876 4.62762 11.5876H11.5685M11.5685 11.5876C10.8147 11.5876 10.2036 12.1987 10.2036 12.9525C10.2036 13.7064 10.8147 14.3175 11.5685 14.3175C12.3224 14.3175 12.9335 13.7064 12.9335 12.9525C12.9335 12.1987 12.3224 11.5876 11.5685 11.5876ZM2.39792 2.71518H13.6147C13.7162 2.71498 13.8165 2.73744 13.9083 2.78093C14.0001 2.82442 14.081 2.88784 14.1451 2.96657C14.2093 3.0453 14.2551 3.13736 14.2791 3.23602C14.3032 3.33469 14.3049 3.43748 14.2842 3.5369L13.5839 7.78609C13.5162 8.09421 13.3438 8.36934 13.096 8.56469C12.8483 8.76004 12.5405 8.86354 12.2251 8.8576H3.54928M6.10862 12.9525C6.10862 13.7064 5.4975 14.3175 4.74364 14.3175C3.98978 14.3175 3.37866 13.7064 3.37866 12.9525C3.37866 12.1987 3.98978 11.5876 4.74364 11.5876C5.4975 11.5876 6.10862 12.1987 6.10862 12.9525Z",
    stroke: "currentColor",
    strokeWidth: 1.36498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.a76e3010.svg";
export { ForwardRef as ReactComponent };